export default "__VITE_ASSET__DS1Wvi59__"